module.exports = __webpack_public_path__ + "assets/home-cd3be3dd00b81344cc92d45bf1b87630.svg";